import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import i18next from "i18next";
import axios from "axios";
import { WarningPopUp } from "hesus-ui-kit";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { handleApiError } from "@utils/errorHandler";
import Header from "./components/Header/Header";
import {
  CompanyViewContainer,
  FlexRow,
  SectionContainer,
} from "./CompanyView.styled";
import { loadSingleCompany } from "../CompanyList/CompanyList.actionCreators";
import GeneralInfo from "./components/GeneralInfo/GeneralInfo";
import ContactList from "../../Contact/ContactList";
import CenterProductsList from "../../CenterProducts/CenterProductsList/CenterProductsList";
import CenterList from "../../Center/CenterList/CenterList";
import MeetingReportsList from "../../MeetingReports/MeetingReportsList";
import WarehouseList from "../../Warehouse/WarehouseList";
import DocumentListView from "../../Document/DocumentList/DocumentListView";
import SiteList from "../../Site/SiteList";
import SolutionsList from "../../Solution/SolutionsList/SolutionsList";
import { TABLE_MEETING_REPORTS_LIST_WITH_BUTTON } from "@utils/constants";
import PurchaseOrderList from "@modules/PurchaseOrder/PurchaseOrderList/PurchaseOrderList";
import InvoiceList from "@modules/Invoice/InvoiceList/InvoiceList";
import NotFound from "@components/Errors/NotFound";
import { setSingleCompanyNotFound } from "../CompanyList/CompanyList.slice";
/**
 * company GeneralInfo,
 * Path - /company/view/{id}
 * @see See [CenterProduct Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2944335881/Company+view+page+-+General+layout)
 * @component
 */
const CompanyView = (props) => {
  const { t } = props;
  const params = useParams();
  const validPaths = [
    "general-info",
    "contacts",
    "meeting-reports",
    "products",
    "warehouses",
    "centres",
    "sites",
    "purchase-orders",
    "invoices",
    "history",
    "documents",
  ];

  const location = useLocation();
  const basePath = location.pathname.split("/").slice(0, 3).join("/") + "/";
  const [companyData, setCompanyData] = useState([]);
  const [isConfirmVisible, setConfirmVisibility] = useState(false);

  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "COMPANY_CONFIRMATION_BOX_DELETE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "COMPANY_CONFIRMATION_BOX_DELETE_CONTENT"
  );
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isRefeshData, setIsRefeshData] = useState(false);

  const dispatch = useDispatch();
  const history = useNavigate();
  const companyId = parseInt(params.id, 10);
  const companyInfo = useSelector((state) => state.companyList.byId[companyId]);

  const selectedCompanyData = useSelector(
    (state) => state.companyList.selectedCompany
  );

  const isSingleCompanyNotFound = useSelector(
    (state) => state.companyList.isSingleCompanyNotFound
  );

  useEffect(() => {
    dispatch(setSingleCompanyNotFound(false));
    if (
      companyInfo !== undefined &&
      parseInt(companyId, 10) === parseInt(companyInfo.id, 10)
    ) {
      setCompanyData(companyInfo);
    }
    if (
      selectedCompanyData !== null &&
      parseInt(companyId, 10) === parseInt(selectedCompanyData.id, 10)
    ) {
      setCompanyData(selectedCompanyData);
    } else fetchCompanyInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyInfo, selectedCompanyData]);

  const handleCompanyStatus = (status) => {
    if (status === 1) {
      setConfirmationBoxTitle("COMPANY_CONFIRMATION_BOX_ENABLE");
      setConfirmationBoxContent("COMPANY_CONFIRMATION_BOX_ENABLE_CONTENT");
    } else {
      setConfirmationBoxTitle("COMPANY_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent("COMPANY_CONFIRMATION_BOX_DELETE_CONTENT");
    }
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .post(
          `/companies/${companyId}/updateStatus`,
          companyData.isActive === 1 ? `0` : 1
        )
        .then((response) => {
          setActionConfirmStatus(false);
          setCompanyData(response?.data[0]);
        })
        .catch((error) => {
          setActionConfirmStatus(false);
          handleApiError(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const fetchCompanyInfo = () => {
    dispatch(
      loadSingleCompany({
        companyId,
      })
    );
  };

  const updateRefeshStatus = () => {
    setIsRefeshData(true);
  };

  useEffect(() => {
    if (isRefeshData) {
      fetchCompanyInfo();
    }
  }, [isRefeshData]);

  useEffect(() => {
    if (isRefeshData) {
      setIsRefeshData(false);
    }
  }, [isRefeshData]);

  if (
    basePath === "/company/view/" &&
    (isSingleCompanyNotFound || !validPaths.includes(params.path))
  ) {
    return <NotFound />;
  }

  return (
    <CompanyViewContainer>
      {companyData?.id && (
        <>
          <FlexRow>
            <SectionContainer>
              <Header
                companyData={companyData}
                handleCompanyStatus={handleCompanyStatus}
                setIsRefeshData={setIsRefeshData}
              />
              {params.path === "general-info" && (
                <GeneralInfo
                  data={companyData}
                  companyId={companyData.id}
                  updateRefeshStatus={updateRefeshStatus}
                />
              )}
              {params.path === "contacts" && (
                <ContactList
                  page="company-view"
                  columnList={[
                    "ID",
                    "CONTACT_COMPANY",
                    "CONTACT_NAME",
                    "CONTACT_FUNCTION",
                    "CONTACT_TYPE",
                    "CONTACT_COMMUNICATION",
                    "ACTIONS",
                  ]}
                  companyId={companyData.id}
                  isCenter={companyData.isCentre}
                  parentCompany={companyData?.parentCompany?.id}
                  countryId={companyData?.platformCountryId}
                  dependancies={JSON.stringify(["roles", "linkedEntities"])}
                />
              )}
              {params.path === "meeting-reports" && (
                <MeetingReportsList
                  type={TABLE_MEETING_REPORTS_LIST_WITH_BUTTON}
                  isHeader="sub-menu"
                  objectType="company"
                  objectId={companyData.id}
                  countryId={companyData?.platformCountryId}
                  columnList={[
                    "ID",
                    "TITLE",
                    "HESUS_PARTICIPANTS",
                    "MEETING_DATE",
                    "ENTITES_LINKED",
                    "RATING",
                    "MEETING_NEXT_DATE",
                    "ACTIONS",
                  ]}
                />
              )}
              {params.path === "products" && (
                <CenterProductsList
                  isHeader={false}
                  centerId={companyData?.centre?.id}
                  companyId={companyData.id}
                />
              )}
              {params.path === "history" && (
                <SolutionsList
                  centreId={companyData?.centre?.id}
                  companyId={companyData.id}
                  displayCreateButton={false}
                  columnList={[
                    "ID",
                    "SITE_COMPANY",
                    "PRODUCT",
                    "PRICE",
                    "COMMENTS",
                    "STAGE",
                    "REQUEST_MATCHINGS_LIST_ALLOCATION",
                  ]}
                />
              )}
              {params.path === "centres" && (
                <CenterList companyId={params.id} />
              )}
              {params.path === "purchase-orders" && (
                <PurchaseOrderList
                  entityId={parseInt(params.id, 10)}
                  countryId={companyData?.platformCountryId}
                  page="company"
                  companyData={{
                    isCenter: companyData?.isCentre,
                    isHaulier: companyData?.isHaulier,
                  }}
                  columnList={[
                    "PURCHASE_ORDER_REFERENCE",
                    ...(companyData?.isSupplier
                      ? ["PURCHASE_ORDER_CENTRE"]
                      : []),
                    "SITES",
                    "PURCHASE_ORDER_ORDER_DATE",
                    "AMOUNT_EXCL_TAX",
                    "PURCHASE_ORDER_HESUS_CONTACT",
                    "STATUS",
                    "ACTIONS",
                  ]}
                />
              )}
              {params.path === "warehouses" && (
                <WarehouseList
                  companyId={params.id}
                  carrierId={companyData?.haulier?.id}
                  companyStatus={companyData.isActive}
                  companyName={companyData.name}
                  countryId={companyData?.platformCountryId}
                />
              )}
              {params.path === "documents" && (
                <DocumentListView
                  entityId={parseInt(params.id, 10)}
                  entityType="companyId"
                  type={2}
                  hesusBoxId={parseInt(companyData.boxFolderId, 10)}
                  updateRefeshStatus={updateRefeshStatus}
                  entityData={companyData}
                />
              )}
              {params.path === "sites" && (
                <SiteList
                  objectType="companyId"
                  objectId={companyData.id}
                  countryId={companyData?.platformCountryId}
                  columnList={[
                    "ID",
                    "SITE_NAME",
                    "SITE_ADDRESS",
                    "STATUS",
                    "SITE_ENQUIRIES",
                  ]}
                />
              )}
              {params.path === "invoices" && (
                <InvoiceList
                  entityId={params.id}
                  entityType="company"
                  entityPlatformCountryId={companyData?.platformCountryId}
                />
              )}
            </SectionContainer>
          </FlexRow>
        </>
      )}
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </CompanyViewContainer>
  );
};
CompanyView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyView);
